import { useNavigate } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

export const useLocalizedNavigate = () => {
  const navigate = useNavigate();
  const { currentLanguage } = useLanguage();

  const localizedNavigate = (path: string) => {
    navigate(`/${currentLanguage}${path}`);
  };

  return localizedNavigate;
};
